<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 30 30"
    :color="color"
    title="Logo WhatsApp"
  >
    <!-- eslint-disable max-len -->
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM15.0267 8.33333C16.7933 8.33333 18.4533 9.02 19.7 10.2733C20.9467 11.52 21.6333 13.18 21.6333 14.9467C21.6333 18.5867 18.6667 21.5533 15.0267 21.5533C13.92 21.5533 12.8333 21.2733 11.8667 20.7467L8.36667 21.6667L9.3 18.24C8.72667 17.24 8.42 16.1067 8.42 14.94C8.42 11.3 11.3867 8.33333 15.0267 8.33333ZM12.2267 19.6667C13.0733 20.1667 14.04 20.4333 15.0267 20.4333C18.0533 20.4333 20.52 17.9733 20.5067 14.9467C20.5067 13.48 19.94 12.1 18.9 11.06C17.8667 10.02 16.4867 9.44667 15.02 9.44667C11.9933 9.44667 9.52667 11.9133 9.52667 14.94C9.52667 15.9733 9.82 16.9867 10.3667 17.86L10.5 18.0667L9.94667 20.0933L12.0267 19.5467L12.2267 19.6667ZM17.8205 16.22C17.9196 16.2683 17.9992 16.3071 18.04 16.3267C18.073 16.3425 18.1033 16.3565 18.1312 16.3693C18.2441 16.4214 18.3159 16.4545 18.3533 16.5133C18.4 16.5867 18.4 16.9133 18.26 17.3C18.1267 17.6867 17.4667 18.04 17.1467 18.0867C16.86 18.1267 16.5 18.1467 16.1067 18.02C15.8667 17.9467 15.56 17.8467 15.1667 17.6733C13.586 16.9914 12.5233 15.438 12.363 15.2037C12.3556 15.193 12.3502 15.185 12.3467 15.18L12.3454 15.1783C12.2605 15.0651 11.6733 14.2824 11.6733 13.4733C11.6733 12.7229 12.0365 12.3244 12.2079 12.1363C12.2223 12.1205 12.2353 12.1062 12.2467 12.0933C12.4 11.9267 12.5733 11.8867 12.6867 11.8867H13.0067C13.0182 11.8874 13.0304 11.8876 13.0429 11.8877C13.139 11.8889 13.2621 11.8904 13.38 12.1733C13.5133 12.5067 13.8467 13.32 13.8867 13.4C13.9267 13.48 13.9533 13.5733 13.9 13.6867C13.8955 13.6958 13.891 13.7046 13.8867 13.7133C13.8406 13.806 13.8065 13.8746 13.7333 13.96C13.7078 13.9898 13.6809 14.0223 13.6537 14.0552C13.5958 14.1252 13.5366 14.1967 13.4867 14.2467C13.4 14.3333 13.32 14.42 13.4133 14.5867C13.5133 14.7533 13.84 15.2933 14.3333 15.7333C14.8692 16.2122 15.3367 16.4132 15.5652 16.5114C15.604 16.528 15.6358 16.5417 15.66 16.5533C15.8267 16.64 15.9267 16.6267 16.02 16.5133C16.1133 16.4067 16.4267 16.0333 16.54 15.8667C16.6533 15.7067 16.76 15.7333 16.9133 15.7867C17.0241 15.832 17.515 16.0712 17.8205 16.22Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
  components: {
    BaseIcon,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 72,
    },
    height: {
      type: [Number, String],
      default: 72,
    },
  },
};
</script>
